module.exports = __webpack_public_path__ + "nuttin-empty-v1.616ccf636616dfd4431e13c21d79c6fb.png";